import AboutUsPageComponent from "components/AboutUsPAge"
import AboutUsMobile from "components/AboutUsPAge/AboutUsMobile"
import CompanyLayout from "components/Layout/CompanyLayout"
import { useLang } from "hooks/useLang"
import useWindowSize from "hooks/useWindowSize"
import { NextSeo } from "next-seo"

export async function getServerSideProps() {
    return {
        props: {},
    }
}

const AboutUSPage = () => {
    const { isMobile } = useWindowSize()
    const { isAr } = useLang()

    const SEO = {
        title: isAr ? "من نحن | باس تيكتس" : "About Us | PassTickets",
        description: isAr
            ? "منصة متكاملة لبيع التذاكر و إنشاء الفعاليات في أي مجال تتخيله؛ سواء كان رياضيًا، ثقافيًا، سياحيًا، اجتماعيًا، تعليميًا، موسيقيًا، ترفيهيًا."
            : "A complete platform for selling tickets and creating events in any field you can imagine; Whether it is sports, cultural, tourist, social,...",
    }

    return (
        <>
            <NextSeo
                title={SEO.title}
                description={SEO.description}
                openGraph={{
                    title: SEO.title,
                    description: SEO.description,
                    images: [
                        {
                            url: "https://cdn.pass-tickets.com/frontend/Desktop - 9 (2).png",
                            alt: "About Us",
                            type: "image/png",
                            height: 600,
                            width: 800,
                        },
                    ],
                }}
            />
            <CompanyLayout>
                {isMobile ? <AboutUsMobile /> : <AboutUsPageComponent />}
            </CompanyLayout>
        </>
    )
}

export default AboutUSPage
